<template>
  <div
    class="absolute left-0 top-[102px] h-1 w-screen opacity-20"
    :class="`bg-${themeColor}-100`"
  ></div>
  <div
    ref="bar theme"
    :style="{ width: barWidth }"
    class="absolute left-0 top-[102px] h-1"
    :class="`bg-${themeColor}-500`"
  ></div>
</template>
<script lang="ts">
  import { defineComponent, ref, inject, computed, watch } from 'vue'
  import gsap from 'gsap'
  import { useThemeColor } from '@/composables/useThemeColor'

  export default defineComponent({
    setup() {
      const bar: any = ref(null)
      const themeColor = computed(() => useThemeColor().value)
      const vueform = inject('vueform') as { formState: any }
      if (!vueform) {
        throw new Error('vueform is not provided')
      }

      const { formState } = vueform
      if (!formState) {
        throw new Error('formState not provided')
      }

      const percent = computed(() => {
        return (formState.value.activeFieldIndex / formState.value.formLength) * 100
      })

      const barWidth = computed(() => `${percent.value}%`)

      watch(percent, (newVal) => {
        let tl = gsap.timeline()
        tl.to(bar.value, {
          duration: 1,
          width: newVal + '%'
        })
      })

      return { bar, barWidth, themeColor }
    }
  })
</script>
